import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import 'glyphicons-only-bootstrap/css/bootstrap.min.css';

class EditPage extends Component {
  constructor() {
    super();
    this.state = {
      data: {},
      next: null,
      saved: false,
      error: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async fetchData(id) {
    try {
      const data = await this.props.getItem(id);
      const next = await this.props.getNextItem([id]);
      this.setState({ data, next, saved: false, error: false });
    } catch (e) {
      this.setState({ saved: false, error: true });
    }
  }

  componentDidMount() {
    this.fetchData(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match && prevProps.match.params && prevProps.match.params.id) {
      if (prevProps.match.params.id !== this.props.match.params.id) {
        this.fetchData(this.props.match.params.id);
      }
    }
  }

  async handleSubmit(data) {
    this.setState({ saved: false, error: false, data });
    try {
      await this.props.saveItem(this.props.match.params.id, data);
      this.setState({ saved: true, error: false });
      window.scrollTo(0, 0);
    } catch (err) {
      this.setState({ saved: false, error: true });
      window.scrollTo(0, 0);
    }
  }
  render() {
    const { data, next, saved, error } = this.state;
    const { formComponent: FormComponent, noImage = false, type } = this.props;
    const loaded = !!data._id;
    return !loaded ? (
      <span>Loading data...</span>
    ) : (
      <div className="EditPage">
        {saved && (
          <div className="alert alert-success" role="alert">
            <strong>Saved!</strong> Thank you for your contribution! Please{' '}
            <Link to={`/${type}/${next._id}`}>click here</Link> to edit another one.
          </div>
        )}
        {error && (
          <div className="alert alert-danger" role="alert">
            <strong>Oh no!</strong> Something went wrong :( Please try again or go back to fill in
            more content.
          </div>
        )}
        <div className="d-flex flew-row justify-content-center EditPage-form">
          {!noImage && (
            <div className="p-2 flex-shrink-0">
              <div className="sticky">
                <a href={data.image} target="_blank">
                  <img alt={data.name} className="card-image" src={data.image} width="320" />
                  <br />
                  Open image in new window
                </a>
              </div>
            </div>
          )}
          <div className="flew-grow-1 p-2">
            <FormComponent formData={data} onSubmit={this.handleSubmit} />
          </div>
        </div>
      </div>
    );
  }
}

export default EditPage;



// WEBPACK FOOTER //
// ./src/EditPage.js